import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import ChatStore from 'stores/ChatStore';
import FirebaseStore from 'stores/FirebaseStore';
import ProfileStore from 'stores/ProfileStore';
import ChatMobileMessages
  from 'pages/ProfileV2/ProfileV2Mobile/MobileBroadcast/MobileChatV2/ChatMobileMessages/ChatMobileMessages';
import { BROADCAST_STATUS } from 'enum/videoPlayer';
import privateRoomLocked from 'images/privateRoomLocked.png';

import styles from './PublicChat.css';


const PublicChat = (props) => {
  const {
    roomName,
    isGroupShowChat,
    showBuyTokensModal,
    onTabsChange,
    isPrivateUserChat,
    isInputFocused,
    toggleGameDrawer,
    recipient,
    setIsInputFocused,
    embedProfileV2,
    isBroadcasterChat,
  } = props;

  const { broadcastStatus } = ProfileStore;
  const {
    messages,
    isPrivateMessageOpen,
  } = ChatStore;

  const { webUsers } = FirebaseStore;

  if (
    isPrivateMessageOpen ||
    isGroupShowChat ||
    isPrivateUserChat ||
    recipient
  ) {
    return null;
  }

  const insidePrivateShow = broadcastStatus === BROADCAST_STATUS.ACCEPTED_INSIDE_PS;

  if (insidePrivateShow) {
    return (
      <div className={styles.privateShowPublicChat}>
        <img alt="Locked icon" src={privateRoomLocked} />
        <p>
          {translate('v2profile.public.chat.disabled')}
        </p>
      </div>
    );
  }

  return (
    <ChatMobileMessages
      embedProfileV2={embedProfileV2}
      handleTabsChange={onTabsChange}
      id="CHAT2"
      isBroadcasterChat={isBroadcasterChat}
      isDesktop={true}
      isInputFocused={isInputFocused}
      isPrivateUserChat={isPrivateUserChat}
      messages={messages}
      recipient={recipient}
      roomName={roomName}
      rosterUsers={webUsers}
      setIsInputFocused={setIsInputFocused}
      showBuyTokensModal={showBuyTokensModal}
      toggleGameDrawer={toggleGameDrawer}
    />
  );
};

PublicChat.propTypes = {
  showBuyTokensModal: PropTypes.func.isRequired,
  onTabsChange: PropTypes.func.isRequired,
  embedProfileV2: PropTypes.bool,
  isBroadcasterChat: PropTypes.bool,
  isGroupShowChat: PropTypes.bool,
  isInputFocused: PropTypes.bool,
  isPrivateUserChat: PropTypes.bool,
  recipient: PropTypes.string,
  roomName: PropTypes.string,
  setIsInputFocused: PropTypes.func,
  toggleGameDrawer: PropTypes.func,
};

PublicChat.defaultProps = {
  embedProfileV2: undefined,
  isBroadcasterChat: undefined,
  isGroupShowChat: false,
  isPrivateUserChat: false,
  isInputFocused: undefined,
  recipient: undefined,
  roomName: undefined,
  setIsInputFocused: undefined,
  toggleGameDrawer: undefined,
};

export default observer(PublicChat);
